/* eslint-disable no-unused-vars */
/**
 * Imports necessary components and hooks from external libraries and local files.
 * @import React - The main library for building user interfaces in React.
 * @import { useRef, useState } from "react" - Hooks for managing mutable values and state in functional components.
 * @import { Card } from "react-bootstrap" - A component from the React Bootstrap library for displaying a card.
 * @import { Controller } from "react-hook-form" - A component from the React Hook Form library for managing form state.
 * @import { useTranslation } from "react-i18next" - A hook from the react-i18next library for internationalization.
 * @import HookForm from "../../components/hookForm/hookForm" - A custom component
 */
import React, { useCallback } from "react";
import { Card } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import HookForm from "../../components/hookForm/hookForm";
import TextField from "../../components/textField/textField";
import FileUpload from "../../components/fileUpload/fileUpload";
import CustomButton from "../../components/customButton/customButton";
import CustomeSelect from "../../components/customSelect/customSelect";
import { RadioButton } from "../../components/radioButton/radioButton";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import { useDropzone } from "react-dropzone";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import moment from "moment-timezone";

const CreateNoticeComponent = (props) => {
  const { t } = useTranslation();
  const dimensions = useWindowDimension();

  const acceptedFileTypes = "image/jpeg, image/png"; // Define accepted file types
  const acceptedDimensions = { width: 512, height: 512 }; // Define accepted dimensions

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    // Handle accepted and rejected files here
    if (acceptedFiles.length > 0) {
    }

    if (rejectedFiles.length > 0) {
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedFileTypes,
    onDrop,
    // Custom validation for dimensions
    validator: (file) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          if (
            img.width === acceptedDimensions.width &&
            img.height === acceptedDimensions.height
          ) {
            resolve();
          } else {
            reject("Invalid image dimensions. Please upload a 512x512 image.");
          }
        };
        img.src = URL.createObjectURL(file);
      });
    },
  });

  /**
   * Destructures the properties from the given props object.
   * @param {{object}} props - The props object containing the properties to destructure.
   * @returns None
   */
  const {
    innerPagetitle,
    backPageFunction,
    placeHolderShimer,
    addNoticeForm,
    roleradioChangeHandler,
    isroleselect,
    handleUploadDocumentFile,
    selectInputRef,
    optionNoticeName,
    onChangeNoticeType,
    formatOptionLabel,
    components,
    textTitlecount,
    handleTextTitleChange,
    handleSubtitleChange,
    textSubTitlecount,
    optionDepotName,
    onChangeDepotName,
    signRequiredChangeHandler,
    issignRequired,
    ispriority,
    priorityChangeHandler,
    uploadedDocumentFile,
    handleClearUploadedUserFile,
    uploadDocumentValid,
    uploadThumNailValid,
    handleUploadDocument,
    handleUploadThumnail,
    handleUploadThumnailFile,
    handleTextdescriptionChange,
    textdescriptioncount,
    createNoticeFunction,
    handleFormSubmit,
    noticeSelectInputRef,
    isUploadingDocument,
    isUploadingDocumentLink,
    isinvalidfile,
    profileImage,
    setIsUploadingDocument,
    setIsUploadingDocumentLink,
    setIsinvalidfile,
    createNoticeLoaderButton,
    uploadedDocumentThumnailFile,
    handleClearUploadedThumnailFile,
    triggerRef,
    breadcrumbHeight,
    headerHeight,
    currentformattedDate,
    expirydatetime,
    onChangeExpiryDate,
    usersigndatetime,
    handleChangeUsersign,
    dimenstionError,
    setDimenstionError,
    expireformattedDate,
  } = props;

  return (
    <>
      <React.Fragment>
        <div className="page-content CreateNoticeManagement">
          <Breadcrumbs
            breadcrumbMainTitle={false}
            breadcrumbInner={true}
            innerPagetitle={innerPagetitle}
            backPageFunction={backPageFunction}
          />

          <Card
            className="Main_Card Main_CreateNotice_Management"
            style={{
              height: dimensions.height - headerHeight - breadcrumbHeight - 50,
            }}
          >
            <Card.Body className="activeTabSupplier">
              <div className="Main_Card_Body">
                <HookForm
                  defaultForm={{
                    signrequired: issignRequired,
                    usersign: "",
                    priority: ispriority,
                  }}
                  className="form-horizontal"
                  onSubmit={(e) => handleFormSubmit(e)}
                  init={(form) => {
                    createNoticeFunction(form);
                  }}
                >
                  {(formMethod) => {
                    return (
                      <>
                        <div className="row">
                          <div className="col-md-12 col-lg-6">
                            {/**
                             * Renders a form with two columns. The left column contains an upload link section
                             * and the right column contains an upload thumbnail section.
                             * @returns The rendered JSX elements.
                             */}
                            <div className="row Desktopview">
                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="wrapper-input uploadLink">
                                  {placeHolderShimer && <CustomeShimer />}
                                  <div className="d-flex">
                                    <p className="field-title">
                                      {t("UPLOAD_DOCUMENT_NOTICE")}
                                    </p>
                                    <p className="requiredStyle">*</p>
                                  </div>
                                  <div className="RadioWrapper">
                                    <div
                                      className="radio-btn-container"
                                      style={{ display: "flex" }}
                                    >

                                      <RadioButton
                                        onChange={roleradioChangeHandler}
                                        id="1"
                                        isSelected={
                                          isroleselect === t("UPLOAD_DOCUMENT")
                                        }
                                        label={t("UPLOAD_DOCUMENT")}
                                        value={t("UPLOAD_DOCUMENT")}
                                        name="uploadDocumnetRadio"
                                      />

                                      <RadioButton
                                        onChange={roleradioChangeHandler}
                                        id="2"
                                        isSelected={
                                          isroleselect === t("ADD_LINK")
                                        }
                                        label={t("ADD_LINK")}
                                        value={t("ADD_LINK")}
                                        name="uploadDocumnetRadio"
                                      />
                                    </div>
                                  </div>
                                  {isroleselect === t("UPLOAD_DOCUMENT") ? (
                                    uploadedDocumentFile ? (
                                      <>
                                        <div className="imagePlaceholder">
                                          <div className="imagePlaceholderWrapper">
                                            <div className="ImageUploader">
                                              <i className="mdi mdi-file-outline" />
                                              <p>
                                                {uploadedDocumentFile.map(
                                                  (i) => i.name
                                                )}
                                              </p>
                                            </div>
                                            <span
                                              className="clearimage"
                                              onClick={
                                                handleClearUploadedUserFile
                                              }
                                            >
                                              <i className="bx bxs-minus-circle" />
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <Controller
                                        name={addNoticeForm.documentfile.name}
                                        rules={
                                          addNoticeForm.documentfile.validate
                                        }
                                        control={formMethod.control}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <>
                                            <FileUpload
                                              onDrop={(acceptedFiles) => {
                                                const validFileTypes =
                                                  Object.keys(
                                                    uploadDocumentValid
                                                  );
                                                const validFiles =
                                                  acceptedFiles.filter((file) =>
                                                    validFileTypes.includes(
                                                      file.type
                                                    )
                                                  );

                                                if (validFiles?.length > 0) {
                                                  handleUploadDocument(
                                                    validFiles,
                                                    setIsUploadingDocument,
                                                    handleUploadDocumentFile
                                                  );
                                                } else {
                                                  setIsinvalidfile(true);
                                                }
                                                onChange(acceptedFiles);
                                              }}
                                              maxSize={100 * 1024 * 1024} // 100 MB
                                              accept={uploadDocumentValid}
                                              triggerOpen={triggerRef}
                                            >
                                              <>
                                                {isUploadingDocument ? (
                                                  <>
                                                    <div className="progress-wrapper">
                                                      <div className="progress">
                                                        <div className="progress-value"></div>
                                                      </div>
                                                      <p>
                                                        {t("UPLOADINGONLY")}
                                                      </p>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    {isinvalidfile ? (
                                                      <div className="fropZoneWrapper inValidUpdaload">
                                                        <i className="mdi mdi-cloud-off-outline" />
                                                        <p>
                                                          {t(
                                                            "INVALID_FILE_FORMAT"
                                                          )}
                                                          <br />
                                                          <span>
                                                            {t(
                                                              "ONLY_DOC_PDF_DOCX_SCORM_AND_PNG_FILE_IS_ALLOWED"
                                                            )}
                                                          </span>
                                                          <br />
                                                          <span className="filelimit">
                                                            {t(
                                                              "MAX_SIZE_100_MB"
                                                            )}
                                                          </span>
                                                        </p>
                                                      </div>
                                                    ) : (
                                                      <div className="fropZoneWrapper">
                                                        <i className="mdi mdi-cloud-upload-outline" />
                                                        <p>
                                                          {t(
                                                            "DRAG_AND_DROP_HERE_OR"
                                                          )}
                                                          <b> {t("BROWSE")}</b>{" "}
                                                          <br />
                                                          <span>
                                                            {t(
                                                              "ONLY_DOC_PDF_DOCX_SCORM_AND_PNG_FILE_IS_ALLOWED"
                                                            )}
                                                          </span>
                                                          <br />
                                                          <span className="filelimit">
                                                            {t(
                                                              "MAX_SIZE_100_MB"
                                                            )}
                                                          </span>
                                                        </p>
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            </FileUpload>
                                          </>
                                        )}
                                      />
                                    )
                                  ) : (
                                    <>
                                      <TextField
                                        formMethod={formMethod}
                                        rules={addNoticeForm.addlink.validate}
                                        name={addNoticeForm.addlink.name}
                                        errors={formMethod?.formState.errors}
                                        autoFocus={true}
                                        type="text"
                                        required={false}
                                        placeholder={t("HTTPS")}
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="wrapper-input Recommended">
                                  {placeHolderShimer && <CustomeShimer />}
                                  <div className="d-flex">
                                    <p className="field-title">
                                      {t("UPLOAD_THUMBNAIL")}
                                    </p>
                                  </div>
                                  <span className="rationText">
                                    {t("RECOMMENDED_SIZE_512_X_512PX")}
                                  </span>
                                  {uploadedDocumentThumnailFile ? (
                                    <>
                                      <div className="imageFile">
                                        <div className="imagePlaceholderWrapper">
                                          <div className="ImagePlaceHolder">
                                            <img
                                              src={profileImage}
                                              alt="placeholder"
                                            ></img>
                                          </div>
                                          <span
                                            className="clearimage"
                                            onClick={
                                              handleClearUploadedThumnailFile
                                            }
                                          >
                                            <i className="bx bxs-minus-circle" />
                                          </span>
                                        </div>
                                        {dimenstionError && (
                                          <p className="errorMsg pt-2">
                                            {t("RECOMMENDED_SIZE_512_X_512PX")}
                                          </p>
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <Controller
                                      name={addNoticeForm.thumbnailfile.name}
                                      rules={
                                        addNoticeForm.thumbnailfile.validate
                                      }
                                      control={formMethod.control}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <>
                                          <FileUpload
                                            onDrop={async (acceptedFiles) => {
                                              const validFileTypes =
                                                Object.keys(
                                                  uploadThumNailValid
                                                );
                                              const validFiles =
                                                acceptedFiles.filter((file) =>
                                                  validFileTypes.includes(
                                                    file.type
                                                  )
                                                );

                                              // Custom validation for image dimensions (512x512)
                                              const isValidDimensions =
                                                await Promise.all(
                                                  acceptedFiles.map(
                                                    async (file) => {
                                                      const img = new Image();
                                                      img.src =
                                                        URL.createObjectURL(
                                                          file
                                                        );

                                                      return new Promise(
                                                        (resolve) => {
                                                          img.onload =
                                                            function () {
                                                              if (
                                                                img.width <=
                                                                512 &&
                                                                img.height <=
                                                                512
                                                              ) {
                                                                resolve(true);
                                                              } else {
                                                                resolve(false);
                                                              }
                                                            };
                                                        }
                                                      );
                                                    }
                                                  )
                                                );
                                              if (
                                                validFiles.length > 0 &&
                                                isValidDimensions.every(
                                                  (isValid) => isValid
                                                )
                                              ) {
                                                handleUploadThumnail(
                                                  validFiles,
                                                  setIsUploadingDocumentLink,
                                                  handleUploadThumnailFile
                                                );
                                                setDimenstionError(false);
                                              } else {
                                                handleUploadThumnail(
                                                  validFiles,
                                                  setIsUploadingDocumentLink,
                                                  handleUploadThumnailFile
                                                );
                                                // Handle validation error here
                                                setDimenstionError(true);
                                              }
                                              onChange(acceptedFiles);
                                            }}
                                            maxSize={10 * 1024 * 1024} // 100 MB
                                            accept={uploadThumNailValid}
                                            triggerOpen={triggerRef}
                                          >
                                            <>
                                              {isUploadingDocumentLink ? (
                                                <>
                                                  <div className="progress-wrapper">
                                                    <div className="progress">
                                                      <div className="progress-value"></div>
                                                    </div>
                                                    <p>{t("UPLOADINGONLY")}</p>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="fropZoneWrapper">
                                                  <i className="mdi mdi-cloud-upload-outline" />
                                                  <p>
                                                    {t("DRAG_AND_DROP_HERE_OR")}
                                                    <b> {t("BROWSE")}</b> <br />
                                                    <span>
                                                      {t(
                                                        "ONLY_PNG_FILE_IS_ALLOWED"
                                                      )}
                                                    </span>
                                                    <br />
                                                    <span className="filelimit">
                                                      {t("MAX_SIZE_10_MB")}
                                                    </span>
                                                  </p>
                                                </div>
                                              )}
                                            </>
                                          </FileUpload>
                                          {dimenstionError && (
                                            <p className="errorMsg pt-2">
                                              {t(
                                                "RECOMMENDED_SIZE_512_X_512PX"
                                              )}
                                            </p>
                                          )}
                                        </>
                                      )}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            {/**
                             * Renders a wrapper div for an input field with a placeholder shimmer effect.
                             * @param {boolean} placeHolderShimer - Determines whether to show the placeholder shimmer effect.
                             * @param {string} t - The translation key for the notice type.
                             * @param {object} addNoticeForm - The form object containing the notice type field.
                             * @param {object} formMethod - The form method object.
                             * @param {function} onChangeNoticeType - The function to handle the change event of the notice type.
                             * @param {function} formatOptionLabel - The function to format the label of the select options.
                             * @param {object} components - The custom components to be used in the select input.
                             * @param
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("NOTICE_TYPE")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addNoticeForm.noticetype.name}
                                rules={addNoticeForm.noticetype.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={noticeSelectInputRef}
                                      options={optionNoticeName}
                                      closeMenuOnSelect={false}

                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      onChange={(item) => {
                                        onChangeNoticeType(item);
                                        onChange(item);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isDisabled={false}
                                      isMulti={false}
                                      className="singleSelecter"
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {/**
                             * Renders a wrapper for an input field with a title, required indicator, and character count badge.
                             * @param {{boolean}} placeHolderShimer - Determines whether to display a placeholder shimmer animation.
                             * @param {{string}} t - The translation function for retrieving localized strings.
                             * @param {{string}} formMethod - The form method for handling form submission.
                             * @param {{object}} addNoticeForm - The form object containing validation rules and field names.
                             * @param {{object}} formMethod?.formState.errors - The errors object from the form state.
                             * @param {{boolean}} autoFocus - Determines whether the input field should be auto-focused.
                             * @param {{boolean}} required - Determines whether the input field is required.
                             *
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("TITLE")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.title.validate}
                                name={addNoticeForm.title.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                placeholder={t("WRITE_HERE")}
                                onChange={handleTextTitleChange}
                              />
                              <span className="badgecount badge bg-success">
                                {textTitlecount} / 100
                              </span>
                            </div>
                            {/**
                             * Renders a wrapper div for an input field with a placeholder shimmer effect.
                             * @param {{boolean}} placeHolderShimer - Determines whether to show the placeholder shimmer effect.
                             * @param {{string}} t - The translation function for translating text.
                             * @param {{string}} formMethod - The form method for the input field.
                             * @param {{object}} addNoticeForm - The form object for adding a notice.
                             * @param {{string}} handleSubtitleChange - The event handler for when the subtitle input field changes.
                             * @param {{number}} textSubTitlecount - The character count for the subtitle input field.
                             * @returns The JSX code for rendering the input field wrapper.
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("SUB_TITLE")}</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.subtitle.validate}
                                name={addNoticeForm.subtitle.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={false}
                                required={false}
                                placeholder={t("WRITE_HERE")}
                                onChange={handleSubtitleChange}
                                type="text"
                                rows={2}
                              />
                              <span className="badgecount badge bg-success">
                                {textSubTitlecount} / 200
                              </span>
                            </div>
                          </div>
                          {/**
                           * Renders a form with various input fields for creating a notice.
                           * @returns {JSX.Element} - The rendered form component.
                           */}
                          <div className="col-md-12 col-lg-6">
                            <div className="wrapper-input description">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("DESCRIPTION")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.description.validate}
                                name={addNoticeForm.description.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={false}
                                required={false}
                                type="text"
                                textarea="textarea"
                                placeholder={t("WRITE_HERE")}
                                onChange={handleTextdescriptionChange}
                                rows={5}
                              />
                              <span className="badgecount badge bg-success">
                                {textdescriptioncount} / 250
                              </span>
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("DEPOT")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addNoticeForm.depot.name}
                                rules={addNoticeForm.depot.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={selectInputRef}
                                      options={optionDepotName}
                                      closeMenuOnSelect={false}
                                      onChange={(item) => {
                                        const resolved = onChangeDepotName(item);
                                        onChange(resolved);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isDisabled={false}
                                      isMulti={true}
                                      value={value}
                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      className="multiSelecter"
                                    />
                                  </>
                                )}
                              />
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("EXPIRY_DATE_AND_TIME")}
                                </p>
                              </div>
                              <div className="dateWrapper">
                                <TextField
                                  formMethod={formMethod}
                                  rules={addNoticeForm.expirydate.validate}
                                  name={addNoticeForm.expirydate.name}
                                  errors={formMethod?.formState.errors}
                                  autoFocus={false}
                                  required={false}
                                  type="date"
                                  min={currentformattedDate}
                                  onChange={(e) => {
                                    onChangeExpiryDate(e);
                                  }}
                                />
                                {(expirydatetime ===
                                  "NaN undefined NaN, 12:NaN AM") || !(expirydatetime) ? (
                                  <p className="datePlaceholder">
                                    -- / -- / --
                                  </p>
                                ) : (
                                  <p>{moment(expirydatetime).format("DD-MM-YYYY")}</p>
                                )}
                              </div>
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("SIGN_REQUIREDNOR")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addNoticeForm.signrequired.name}
                                    rules={addNoticeForm.signrequired.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            signRequiredChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="3"
                                          isSelected={
                                            issignRequired === t("YES")
                                          }
                                          label={t("YES")}
                                          value={t("YES")}
                                          name="signrequired"
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            signRequiredChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="4"
                                          isSelected={
                                            issignRequired === t("No")
                                          }
                                          label={t("No")}
                                          value={t("No")}
                                          name="signrequired"
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            {issignRequired === t("YES") && (
                              <div className="wrapper-input">
                                {placeHolderShimer && <CustomeShimer />}
                                <div className="d-flex">
                                  <p className="field-title">
                                    {t("USER_TO_SIGN_BY")}
                                  </p>
                                  <p className="requiredStyle">*</p>
                                </div>
                                <div className="dateWrapper">
                                  <TextField
                                    formMethod={formMethod}
                                    rules={addNoticeForm.usersign.validate}
                                    name={addNoticeForm.usersign.name}
                                    errors={formMethod?.formState.errors}
                                    autoFocus={false}
                                    required={false}
                                    type="date"
                                    min={currentformattedDate}
                                    max={expireformattedDate}
                                    value={usersigndatetime}
                                    onChange={(e) => {
                                      handleChangeUsersign(e);
                                    }}
                                  />
                                  {(usersigndatetime ===
                                    "NaN undefined NaN, 12:NaN AM") || !(usersigndatetime) ? (
                                    <p className="datePlaceholder">
                                      -- / -- / --
                                    </p>
                                  ) : (
                                    <p>{moment(usersigndatetime).format("DD-MM-YYYY")}</p>
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="wrapper-input mb-0">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("PRIORITY")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addNoticeForm.priority.name}
                                    rules={addNoticeForm.priority.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="5"
                                          isSelected={ispriority === t("HIGH")}
                                          label={t("HIGH")}
                                          value={t("HIGH")}
                                          name={t("PRIORITY")}
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="6"
                                          isSelected={
                                            ispriority === t("MEDIUM")
                                          }
                                          label={t("MEDIUM")}
                                          value={t("MEDIUM")}
                                          name={t("MEDIUM")}
                                        />
                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="7"
                                          isSelected={ispriority === t("LOW")}
                                          label={t("LOW")}
                                          value={t("LOW")}
                                          name={t("LOW")}
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**
                         * Renders a form button component with optional loading state and disabled state.
                         * @param {{string}} className - The class name for the button component.
                         * @param {{string}} type - The type of the button (e.g., "submit").
                         * @param {{boolean}} disabled - Whether the button should be disabled.
                         * @param {{boolean}} loading - Whether the button should be in a loading state.
                         * @param {{string}} children - The text content of the button.
                         * @returns A JSX element representing the form button component.
                         */}
                        <div className="mt-3 d-flex FormButton">
                          <div className="wrapper-input">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"
                              // disabled={!formMethod?.formState.isValid || (typeof formMethod.getValues("documentfile") !== 'object' && typeof formMethod.getValues("documentfile") !== 'string')}
                              disabled={
                                isroleselect === t("UPLOAD_DOCUMENT")
                                  ? !formMethod?.formState.isValid || typeof formMethod.getValues("documentfile") !== 'object'
                                  : !formMethod?.formState.isValid
                              }
                              loading={createNoticeLoaderButton}
                            >
                              {t("CREATE")}
                            </CustomButton>
                          </div>
                        </div>
                      </>
                    );
                  }}
                </HookForm>
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default CreateNoticeComponent;
